import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashboardState {
  dashboardData: any;
}

const initialState: DashboardState = {
  dashboardData: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData: (state, action: PayloadAction<any>) => {
      state.dashboardData = action.payload;
    },

    clearDashboardData: (state) => {
      state.dashboardData = null;
    },
  },
});

export const { setDashboardData, clearDashboardData } = dashboardSlice.actions;

export default dashboardSlice.reducer;
